export const FAQ_CATEGORIES = [
  "general",
  "documents",
  "monitoring",
  "risks",
  "security",
  "reports",
  "commercial",
];

export const FAQ_QUESTIONS = [
  { id: "what_is_qenva", category: "general", highlight: true },
  { id: "why_need_qenva", category: "general" },
  { id: "who_is_qenva_for", category: "general" },

  { id: "doc_types", category: "documents", highlight: true },
  { id: "scanned_invoices", category: "documents" },
  { id: "what_happens_after_import", category: "documents" },
  { id: "chat_with_documents", category: "documents" },
  { id: "must_read_full_doc", category: "documents" },

  { id: "continuous_monitoring", category: "monitoring", highlight: true },
  { id: "alert_types", category: "monitoring" },
  { id: "daily_brief", category: "monitoring" },
  { id: "custom_reminders", category: "monitoring" },

  { id: "crosscheck", category: "risks" },
  { id: "crosscheck_multi_site", category: "risks" },
  { id: "decisions_module", category: "risks" },

  { id: "documents_secure", category: "security", highlight: true },
  { id: "who_sees_documents", category: "security" },

  { id: "executive_report", category: "reports" },
  { id: "invite_team", category: "reports" },

  { id: "pricing_plans", category: "commercial", highlight: true },
  { id: "no_install_needed", category: "commercial" },
  { id: "cancel_anytime", category: "commercial" },
];
